import { Component, OnInit } from '@angular/core';
import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';

import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-splash-page',
  templateUrl: './splash-page.component.html',
  styleUrls: ['./splash-page.component.scss'],
  standalone: true,
  imports: [ButtonModule, ToastModule, RouterLink],
  providers: [MessageService],
})
export class SplashPageComponent implements OnInit {
  private jwtHelper = new JwtHelperService();
  private routerLink: string[] = environment.splashPageRouterLink;
  private longPressTimer: ReturnType<typeof setTimeout> | null = null;

  private authService = inject(AuthService);
  private messageService = inject(MessageService);

  ngOnInit() {
    // Check if user has a valid token
    const token = this.authService.getToken();

    if (token && !this.jwtHelper.isTokenExpired(token)) {
      // Valid token exists, button will skip login and go directly to companies
      this.routerLink = ['/', 'main', 'companies'];
    }
  }

  getRouterLink() {
    return this.routerLink;
  }

  onTouchStart() {
    console.log('Long press started - holding for 3 seconds...');
    this.longPressTimer = setTimeout(() => {
      console.log('3 seconds elapsed - triggering notification!');
      this.triggerUpdateNotification();
    }, 3000);
  }

  onTouchEnd() {
    console.log('Touch/click ended');
    if (this.longPressTimer) {
      console.log('Cancelling long press timer');
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }

  private triggerUpdateNotification() {
    console.log('Triggering PWA update notification');
    this.messageService.add({
      key: 'update',
      severity: 'info',
      summary: 'Update Available',
      detail: 'A new version of the app is ready. Click Update to reload.',
      sticky: true,
    });
  }
}
